import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { TransitionGroup, Transition } from 'transition-group';

import i18n from 'i18n';
import { rateApp, unrateApp } from 'actions/registry';
import { setLoadingRateApp } from 'actions/gallery';

import { StarIcon, StarGroup } from './Stars';

const RatingTransitionWrapper = styled.div`
  opacity: 1;

  &.enter {
    opacity: 0;
  }

  &.enter.enter-active {
    transition: opacity 100ms ease-out;
    opacity: 1;
  }

  &.leave.leave-active {
    transition: opacity 100ms ease-out;
    opacity: 0;
  }
`;

export const RatingTransition = ({ show, children }) => (
  <TransitionGroup component="div" duration={200}>
    {show && (
      <Transition key="rating-transition">
        <RatingTransitionWrapper>{children}</RatingTransitionWrapper>
      </Transition>
    )}
  </TransitionGroup>
);

const RatingsWrapper = styled.div`
  display: flex;
  height: 45px;
  justify-content: center;
  align-items: center;

  &.enter {
    opacity: 0;
  }

  &.enter.enter-active {
    opacity: 1;
    transition: opacity 100ms ease-in;
  }

  &.leave {
    opacity: 1;
  }

  &.leave.leave-active {
    opacity: 0;
    transition: opacity 100ms ease-in;
  }
`;

const Star = styled(StarIcon)`
  &&:last-of-type {
    margin: 0;
  }
`;

const StarInput = ({ starValue, onClick, ...props }) => (
  <Star onClick={() => onClick(starValue)} {...props} />
);

class RatingInput extends Component {
  state = {
    setStarValue: null
  };

  handleClick = (starValue) => {
    const { onRate } = this.props;

    this.setState(
      {
        setStarValue: starValue
      },
      () => {
        if (onRate) {
          onRate(starValue);
        }
      }
    );
  };

  render() {
    const { app } = this.props;

    const stars = [];
    if (!app.isRatingNow) {
      for (let i = 1; i <= 5; i += 1) {
        stars.push(
          <StarInput
            key={i}
            size={45}
            margin={12}
            starValue={i}
            filled={i <= this.state.setStarValue}
            onClick={this.handleClick}
          />
        );
      }
    }

    return (
      <TransitionGroup component="div" duration={200}>
        {app.isRatingNow ? (
          <Transition key="thank-you" duration={200}>
            {
              <RatingsWrapper>
                {i18n('component.Ratings.thankYouText')()}
              </RatingsWrapper>
            }
          </Transition>
        ) : (
          <RatingsWrapper>{stars}</RatingsWrapper>
        )}
      </TransitionGroup>
    );
  }
}

export const ConnectedRatingInput = connect(null, (dispatch, props) => ({
  onRate(starValue) {
    const id = props.app.id;
    dispatch(setLoadingRateApp(id, true));
    setTimeout(() => dispatch(setLoadingRateApp(id, false)), 2000);
    return dispatch(rateApp(id, starValue));
  }
}))(RatingInput);

const UnrateWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SmallStar = (props) => <StarIcon size={14} margin={1.2} {...props} />;

const Stars = styled.div`
  flex: 1;
  margin-left: 8px;
`;

const RemoveButton = styled.div`
  color: #939c9e;
`;

const UnrateInput = ({ app, onRemove }) => (
  <UnrateWrapper>
    {i18n('component.Ratings.youRatedText')()}{' '}
    <Stars>
      <StarGroup filledStars={app.userRating.stars} Star={SmallStar} />
    </Stars>
    <RemoveButton onClick={onRemove}>
      {i18n('component.Ratings.removeText')()}
    </RemoveButton>
  </UnrateWrapper>
);

export const ConnectedUnrateInput = connect(null, (dispatch, props) => ({
  onRemove() {
    return dispatch(unrateApp(props.app.id));
  }
}))(UnrateInput);
